import React from 'react';
import { Grid, Skeleton, Typography } from '@mui/material';
import { ACCOUNT_PERSONAL_DETAILS_PHRASES } from '@/consts/phrases/accountPhrases';
import { usePhrase } from '@/hooks/general/usePhrase/usePhrase';

export const AccountPersonalDetailsFormSkeleton = () => {
    const { t } = usePhrase();

    return (
        <>
            <Grid container spacing={2}>
                <Grid size={12}>
                    <Skeleton height={80} />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Skeleton height={50} />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Skeleton height={50} />
                </Grid>
                <Grid size={12}>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                        {t(ACCOUNT_PERSONAL_DETAILS_PHRASES.ADDRESS_HEADER)}
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Skeleton height={50} />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Skeleton height={50} />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Skeleton height={50} />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Skeleton height={50} />
                </Grid>
                <Grid size={12}>
                    <Skeleton height={50} />
                </Grid>
                <Grid size={12}>
                    <Skeleton height={50} />
                </Grid>
                <Grid size={12}>
                    <Skeleton height={50} />
                </Grid>
                <Grid size={12}>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                        {t(ACCOUNT_PERSONAL_DETAILS_PHRASES.SETTINGS_HEADER)}
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Skeleton height={50} />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Skeleton height={50} />
                </Grid>
                <Grid size={12}>
                    <Skeleton height={50} />
                </Grid>
            </Grid>
            <Grid
                container
                sx={{
                    justifyContent: 'flex-end',
                    marginTop: 2,
                }}
            >
                <Skeleton height={50} width={80} />
            </Grid>
        </>
    );
};
